<div class="content-area">
  <h2>3D Configuration</h2>
  <clr-tabs #tabs>
    <clr-tab>
      <button clrTabLink>Editor</button>
      <ng-template [(clrIfActive)]="editorActive">
        <clr-tab-content>
          <app-bms-building-editor *ngIf="node" [nodeId]="node.id" [nodeTypeId]="node.nodeTypeId" [customer]="customer"
            [buildingService]="adminService"></app-bms-building-editor>
        </clr-tab-content>
      </ng-template>
    </clr-tab>
    <clr-tab>
      <button clrTabLink>Files</button>
      <ng-template [(clrIfActive)]="filesActive">
        <clr-tab-content>
          <div class="card">
            <div class="card-block">
              <div class="card-text">
                <table class="table table-compact table-vertical backup">
                  <caption style="margin-bottom: 1em;">
                    BIM file
                  </caption>
                  <tbody>
                    <tr>
                      <th class="left" style="width: 100px;">BIM file</th>
                      <td *ngIf="bimFileInfo" class="left">{{bimFileInfo.name}}
                        <!-- <clr-icon shape="download-cloud" style="cursor: pointer" (click)="downloadGatewayFile()"></clr-icon> -->
                      </td>
                      <td *ngIf="!bimFileInfo" class="left">---</td>
                      <td *ngIf="bimFileInfo" style="width: 5px;" class="right">
                        <clr-icon shape="download-cloud" style="cursor: pointer" (click)="downloadBIMFile()"></clr-icon>
                      </td>
                      <td *ngIf="bimFileInfo" style="width: 5px;" class="right">
                        <clr-icon shape="trash" style="cursor: pointer" (click)="deleteBIMFile()"></clr-icon>
                      </td>
                    </tr>
                    <tr>
                      <th class="left" style="width: 100px;">Time</th>
                      <td class="left">{{bimFileInfo ? dateHelper.utils.format(bimFileInfo.lastModified,
                        'keyboardDateTime')
                        :
                        '---'}}</td>
                      <td *ngIf="bimFileInfo" style="width: 5px;" class="right"></td>
                      <td *ngIf="bimFileInfo" style="width: 5px;" class="right"></td>
                    </tr>
                  </tbody>
                </table>

                <form clrForm clrLayout="vertical" autocomplete="off">
                  <clr-input-container>
                    <label class="clr-col-12">Upload BIM file, select or drop file.</label>
                    <input clrInput class="clr-col-12" name="bimfile_file" #file type="file"
                      (change)="selectBIMFile(file)" />
                  </clr-input-container>
                </form>

                <button type="button" class="btn btn-sm btn-outline" [clrLoading]="uploadingState"
                  [disabled]="!uploadFile" (click)="uploadBIMFile()">
                  <clr-icon shape="import"></clr-icon>
                  Upload BIM file
                </button>

                <table class="table table-compact table-vertical backup">
                  <caption style="margin-bottom: 1em;">
                    Babylon file
                  </caption>
                  <tbody>
                    <tr>
                      <th class="left" style="width: 100px;">Babylon file</th>
                      <td *ngIf="babylonFileInfo" class="left">{{babylonFileInfo.name}}
                        <!-- <clr-icon shape="download-cloud" style="cursor: pointer" (click)="downloadGatewayFile()"></clr-icon> -->
                      </td>
                      <td *ngIf="!babylonFileInfo" class="left">---</td>
                      <td *ngIf="babylonFileInfo" style="width: 5px;" class="right">
                        <clr-icon shape="download-cloud" style="cursor: pointer"
                          (click)="downloadBabylonFile()"></clr-icon>
                      </td>
                      <td *ngIf="babylonFileInfo" style="width: 5px;" class="right">
                        <clr-icon shape="trash" style="cursor: pointer" (click)="deleteBabylonFile()"></clr-icon>
                      </td>
                    </tr>
                    <tr>
                      <th class="left" style="width: 100px;">Time</th>
                      <td class="left">{{babylonFileInfo ? dateHelper.utils.format(babylonFileInfo.lastModified,
                        'keyboardDateTime')
                        :
                        '---'}}</td>
                      <td *ngIf="babylonFileInfo" style="width: 5px;" class="right"></td>
                      <td *ngIf="babylonFileInfo" style="width: 5px;" class="right"></td>
                    </tr>
                  </tbody>
                </table>

                <form clrForm clrLayout="vertical" autocomplete="off">
                  <clr-input-container>
                    <label class="clr-col-12">Upload Babylon file, select or drop file.</label>
                    <input clrInput class="clr-col-12" name="babylonfile_file" #babylonfile type="file"
                      (change)="selectBabaylonFile(babylonfile)" />
                  </clr-input-container>
                </form>

                <button type="button" class="btn btn-sm btn-outline" [clrLoading]="babylonUploadingState"
                  [disabled]="!babylonUploadFile" (click)="uploadBabaylonFile()">
                  <clr-icon shape="import"></clr-icon>
                  Upload Babylon file
                </button>
              </div>
            </div>
          </div>
        </clr-tab-content>
      </ng-template>
    </clr-tab>
    <clr-tab>
      <button clrTabLink>Preview</button>
      <ng-template [(clrIfActive)]="previewActive">
        <clr-tab-content>
          <div class="content-area">
            <div class="preview-dashboard">
              <xproj-dashboard  #previewDashboard [editMode]="false" [showDashboardSettings]="false"
              [systemDashboard]="true" [dashboardId]="'bms_customers_3dpreview'" [enableExport]="false"
              [dashboardTag]="'latest'" [responsiveWidth]="responsiveWidth"
              (onWidgetOutputChanged)="onPreviewDashboardOutputChanged($event)"
              [dashboardOutputParameters]="previewParameters"></xproj-dashboard>
            </div>

            <form clrForm  class="camera-form" *ngIf="buildingCompass && buildingCamera">
              <p>*ctrl+click to select compass postion. </p>
              <clr-input-container>
                <label class="clr-col-8">Compass degrees (0-360):</label>
                <input clrInput class="clr-col-4" type="number" min="0" max="360" step="1" placeholder="" name="compassalphadegrees" [(ngModel)]="buildingCompass.alphadegrees" />
              </clr-input-container>

              <p><b>Camera</b></p>

              <clr-input-container>
                <label class="clr-col-8">Alpha degrees (0-360):</label>
                <input clrInput class="clr-col-4" type="number" min="0" max="360" step="1" placeholder="" name="cameraalpha" [(ngModel)]="buildingCamera.alpha" />
              </clr-input-container>
              <clr-input-container>
                <label class="clr-col-8">Beta degrees (0-180):</label>
                <input clrInput class="clr-col-4"type="number" min="0" max="180" step="1" placeholder="" name="camerabeta" [(ngModel)]="buildingCamera.beta" />
              </clr-input-container>
              <clr-input-container>
                <label class="clr-col-8">Radius:</label>
                <input clrInput class="clr-col-4" type="number" min="1" max="10000" step="1" placeholder="" name="cameraradius" [(ngModel)]="buildingCamera.radius" />
              </clr-input-container>
              <clr-input-container>
                <label class="clr-col-8">Radius lower limit:</label>
                <input clrInput class="clr-col-4" type="number" min="1" max="10000" step="1" placeholder="" name="cameraradiuslowerlimit" [(ngModel)]="buildingCamera.radiusLowerLimit" />
              </clr-input-container>
              <clr-input-container>
                <label class="clr-col-8">Radius upper limit:</label>
                <input clrInput class="clr-col-4" type="number" min="1" max="10000" step="1" placeholder="" name="cameraradiusupperlimit" [(ngModel)]="buildingCamera.radiusUpperLimit" />
              </clr-input-container>
            </form>
            <button type="button" class="btn btn-secondary" (click)="save();">
              Save
            </button>
          </div>
        </clr-tab-content>
      </ng-template>
    </clr-tab>
  </clr-tabs>
</div>
